import Feedback from '@betahuhn/feedback-js'
import { Subject } from 'rxjs'

export class FeedbackService {
   productFeedback: any = {}
   onProductFeedback = new Subject()
   constructor() {
      this.productFeedback = new Feedback({
         events: true,
         primary: '#09a961',
         typeMessage: 'Need help/Feedback?',
         inputPlaceholder: 'Enter your message here!',
         types: {
            'Missing product/service': {
               text: 'Missing product/service',
               icon: '⚠️',
            },
            Bug: { text: 'Bug', icon: '🐞' },
            Idea: {
               text: 'Idea',
               icon: '💡',
            },
         },
      })
      window.addEventListener('feedback-submit', (event: any) => {
         //console.log(event);
         this.onProductFeedback.next(event)
         event.preventDefault()
      })
   }

   showProductFeedbackModal() {
      this.productFeedback.renderModal()
   }
}
